<template>
  <v-card>
    <v-card-text>
      <v-data-table
        v-if="budgetId"
        v-bind="dataTableAttrs"
        :headers="headersShown"
        :items="list"
        :loading="isLoading"
        :options.sync="options"
        :server-items-length="total"
        :items-per-page.sync="itemsPerPage"
        v-model="selectedItems"
        @update:items-per-page="handleItemsPerPageUpdated"
      >
        <template v-slot:top>
          <rs-table-title-bar
            v-if="$refs.headSearch"
            :title="isHouse ? 'Muaf Bağımsız Bölümler' : 'Kapsam Dışı Giderler'"
            icon=""
            @click:add="handleAddClick"
            :add-route="'#'"
            @clear-filters="$refs.headSearch.reset"
            @reload="loadList"
            hide-edit
            :search.sync="search.query"
            v-bind="titleBarAttrs"
            :delete-enabled="selectedItems.length === 1"
            @click:delete="handleDeleteClick"
            show-delete=""
          >
          </rs-table-title-bar>
        </template>

        <!-- eslint-disable-next-line -->
        <template v-slot:body.prepend="{ headers }">
          <rs-table-head-search
            :headers="headers"
            :search.sync="search"
            ref="headSearch"
          />
        </template>

        <!-- eslint-disable-next-line -->
        <template v-slot:item.exemption_ratio="{ value }" v-if="isHouse">
          <rs-table-cell-number :value="value" />
        </template>

        <!-- eslint-enable -->
      </v-data-table>
      <ExemptForm ref="exemptForm" @saved="loadList" />
      <rs-confirm
        ref="confirmDelete"
        :loading="isLoading"
        @confirmed="handleDelete"
        @cancelled="$refs.confirmDelete.hide()"
      />
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";

import { debounce } from "@/core/plugins/debounce";
import { hasDataTable, hasExport, hasPermissions } from "../../../../mixins";
import ExemptForm from "./ExemptForm";

export default {
  mixins: [hasDataTable, hasExport, hasPermissions],
  props: {
    /**
     * Budget ID
     */
    budgetId: {
      type: Number,
      required: true,
      default: null,
    },
    /**
     * Is House
     */
    isHouse: {
      type: Boolean,
      required: true,
      default: null,
    },
  },
  components: {
    ExemptForm,
  },
  computed: {
    ...mapGetters(["expenseTypeList"]),
  },
  data() {
    return {
      titleBarAttrs: {
        exportUrl: () => "budget-exempts",
        exportParams: this.getParams,
      },
      headers: [],
    };
  },
  mounted() {
    this.$nextTick(() => {
      if (this.isHouse) {
        this.headers.push(
          {
            text: "BB No",
            value: "house_name",
            searchable: "text",
            align: "center",
          },
          {
            text: "Muafiyet Oranı (%)",
            value: "exemption_ratio",
            searchable: "number",
            align: "end",
          }
        );
      } else {
        this.headers.push(
          {
            text: "Gider Türü",
            value: "expense_type_name",
            searchValue: "expense_type_ids",
            searchable: "multiselect",
            options: () => this.expenseTypeList,
          },
          {
            text: "Gider Tipi",
            value: "child_expense_type_name",
            searchable: "text",
          }
        );
      }
      this.generateExportColumns(this.headers);
      this.loadList();
    });
  },
  methods: {
    loadList() {
      if (this.isLoading || !this.budgetId) {
        return;
      }

      this.isLoading = true;
      this.list = [];

      const params = this.getParams();

      this.$api
        .query(`budget-exempts`, { params })
        .then((response) => {
          if (response.data && response.data.data) {
            this.list = response.data.data;
          }

          if (response.data && response.data.meta) {
            this.total = response.data.meta.total;
            this.options.page = response.data.meta.current_page;
            this.itemsPerPage = response.data.meta.per_page;
            this.options.itemsPerPage = this.itemsPerPage;
          }
        })
        .catch((error) => {
          this.handleError(error);
        })
        .finally(() => (this.isLoading = false));
    },
    getParams() {
      const params = Object.assign(
        this.buildSearchParams(this.search, this.options)
      );

      params.budget_id = this.budgetId;
      params.order_by = "id";

      if (this.isHouse) {
        params.type = "house";
      } else {
        params.type = "expense_type";
      }

      return params;
    },
    handleAddClick() {
      this.$refs.exemptForm.show(this.budgetId, this.isHouse);
    },
    handleDelete() {
      this.isLoading = true;

      this.$api
        .delete(`budget-exempts/${this.selectedItems[0].id}`)
        .then(() => {
          this.$toast.success("Silindi");
          this.selectedItems = [];
        })
        .catch((error) => {
          this.handleError(error);
        })
        .finally(() => {
          this.isLoading = false;
          this.$nextTick(() => this.loadList());
        });
      this.$refs.confirmDelete.hide();
    },
    handleDeleteClick() {
      let text = "";
      if (this.isHouse) {
        text = "Bütçe muafiyet BB'sini silmek istediğinizden emin misiniz?";
      } else {
        text = "Bütçe kapsam dışı giderini silmek istediğinizden emin misiniz?";
      }
      this.$refs.confirmDelete.show(text);
    },
  },
  watch: {
    options: {
      handler() {
        this.loadList();
      },
      deep: true,
    },
    search: {
      handler: debounce(function () {
        this.loadList();
      }),
      deep: true,
    },
    budgetId: {
      handler() {
        this.loadList();
      },
    },
  },
};
</script>
